import styled from "styled-components";

export const BasicsInfoStyled = styled.div`
  .header {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;

    .fields {
      display: flex;
      gap: 20px;
      > :first-child {
        margin-top: -20px;
      }
      align-items: center;
      .select {
        width: 180px;
      }
    }
  }

  .selects {
    width: 150px;
    display: flex;
    gap: 10px;

    .MuiInputBase-root {
      background-color: #301d35;
      .MuiTypography-root {
        color: white;
        font-weight: bold;
      }
    }
    .css-16l2090-MuiSvgIcon-root-MuiSelect-icon {
      color: white;
    }
  }
`;
